module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-up-right-84dd98dd.svg";